import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sl_icon.png")